<template>
  <div>
    <div class="plan">
      <div class="t">
        {{ title }}
        <div v-if="status" class="statusShow error">登记驳回</div>
        <div v-if="status" class="statusShow error">审核退回</div>
        <div v-if="status" class="statusShow waiting">登记中</div>
        <div v-if="status" class="statusShow end">已登记</div>
        <div v-if="status" class="statusShow end">审核通过</div>
      </div>
      <div v-if="back" class="return" @click="goCreat()">
        返回上一级 <img src="@/assets/img/return.png" alt="" />
      </div>
    </div>
    <el-dialog :visible.sync="errorShow" width="30%">
      <span>该页面还有项目填写出错，确定放弃编辑？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="errorShow = false">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Return",
  watch: {},
  data() {
    return {
      errorShow: false //是否放弃修改错误信息弹窗
    };
  },
  props: {
    id: {
      default: null,
      type: Number
    },
    title: {
      default: "信息登记",
      type: String
    },
    status: {
      default: false,
      type: Boolean
    },
    history: {
      default: true,
      type: Boolean
    },
    back: {
      default: true,
      type: Boolean
    },
    goHistory: {
      default: true,
      type: Boolean
    },
    goStaff: {
      default: true,
      type: Boolean
    },
    //为false的时候，这边有报错的信息
    value: {
      default: true,
      type: Boolean
    }
  },
  methods: {
    confirm() {
      this.errorShow = false;
      this.$router.back();
    },
    goCreat() {
      console.log(this.goHistory, "this.goHistory");
      if (!this.goHistory) {
        this.$router.push({ name: "yjIndex", query: { record_id: this.id } });
        return false;
      }
      if (!this.goStaff) {
        this.$router.push({
          name: "createStaff",
          query: { record_id: this.id }
        });
        return false;
      }
      //excel里面有新增错误的值
      if (this.history) {
        if (!this.value) {
          //弹出 是否放弃修改错误信息弹窗
          this.errorShow = true;
          return false;
        } else {
          this.$router.back();
          return false;
        }
      } else {
        this.$router.push({ name: "homeCreate" });
        return false;
      }
    },
    returnH() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.plan {
  height: 60px;
  background: #ffffff;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;

  .t {
    font-size: 20px;
    color: #333333;
    display: flex;
    align-items: center;

    .statusShow {
      font-size: 12px;
      color: #ffffff;
      margin-left: 8px;
      padding: 2px;
      border-radius: 2px;
    }

    .error {
      background: rgb(243, 35, 35);
    }

    .waiting {
      background: rgb(68, 150, 241);
    }

    .end {
      background: rgb(37, 162, 45);
    }
  }

  .return {
    display: flex;
    cursor: pointer;
    align-items: center;
    font-size: 14px;
    color: #4379f6;

    img {
      width: 12px;
      height: 10px;
      margin-left: 3px;
    }
  }
}
</style>
